/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */

import "./style.css";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import lod_ from "lodash";
import FormActions from "redux-react/actions/formAction";
import SettingsActions from "redux-react/actions/settingsActions";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import i18n from "i18n";
import DictionaryMenu from "pages/settings/filters/DictionaryMenu";

import { Box, Icon } from "@mui/material";
import { COLLECTIONS, CATALOGS } from "helpers/constants";
import MDButton from "components/Basics/MDButton";
import { display } from "redux-react/reducers/snackBarReducer";

/**
 * Component for input
 */
export default function SwitchAccount({ user, targetCluster, close, catalogCluster }) {
	const [listOfAccount, setListOfAccount] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		const onSuccess = res => {
			setListOfAccount(res?.items ?? []);
		};
		dispatch(
			FormActions.getItemsFromCollection(
				COLLECTIONS.ACCOUNT,
				{ query: { active: true, isClient: true }, catalog: CATALOGS.legacy },
				onSuccess,
				CATALOGS.legacy
			)
		);
	}, []);

	const handleSwitchAccount = targetAccountID => {
		const onSuccess = () => {
			close();
		};

		dispatch(
			FormActions.switchAccount(user, targetAccountID, targetCluster, onSuccess, catalogCluster)
		);
	};

	return (
		<Box>
			{lod_.isEmpty(listOfAccount) ? (
				<Box>{i18n.t("FORMS.emptyAccount")}</Box>
			) : (
				<Box style={{ display: "flex", flexWrap: "wrap" }}>
					{listOfAccount
						.sort((a, b) => a?.accountName.localeCompare(b?.accountName))
						.map(account => (
							<Box pr={2} pt={2}>
								<MDButton
									color="dark"
									variant="contained"
									disabled={account?.accountID === user?.accountID}
									onClick={() => handleSwitchAccount(account?.accountID)}
								>
									{account?.accountName}
								</MDButton>
							</Box>
						))}
				</Box>
			)}
		</Box>
	);
}
